var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"family-layout hero is-large"},[_c('div',{staticClass:"hero-body"},[_c('div',{staticClass:"container has-text-centered"},[_c('div',{staticClass:"column is-12"},[_c('router-view')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }